"use strict";

module.exports = require("./is-implemented")() ? Array.from : require("./shim");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/array/from/index.js
// module id = ../../../node_modules/es5-ext/array/from/index.js
// module chunks = 1